export const ENVIRONMENT_DEVELOPMENT =
  !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export const BASE_DOMAIN = ENVIRONMENT_DEVELOPMENT
  ? process.env.REACT_APP_API_HOST || 'http://localhost:8008'
  : window.location.origin;

export const API_BASE_DOMAIN = BASE_DOMAIN + '/api';
export const API_CLIENT_DOMAIN = API_BASE_DOMAIN + '/ui';
export const API_PUBLIC_DOMAIN = API_BASE_DOMAIN + '/public';

export const PARAMS = {
  CLIENT_ID: 'client_id',
  WHITELABEL: 'whitelabel',
  CODE: 'code',
};

export const HEADERS = {
  NAMES: {
    AUTHORIZATION: 'Authorization',
    CONTENT_TYPE: 'Content-Type',
  },
  VALUES: {
    APPLICATION_JSON: 'application/json',
  },
};

export const TOKEN = 'token';
